"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeGasFees = normalizeGasFees;
const tslib_1 = require("tslib");
const ethers_1 = require("ethers");
const index_1 = require("./index");
/**
 * The function estimates gas fee with EIP-1559.
 * @returns an object containing:
 * - maxFeePerGas: The maximum fee per unit of gas for this transaction.
 *   maxFeePerGas = baseFeePerGas + maxPriorityFeePerGas
 *   The baseFeePerGas depends on how full the previous blocks were.
 * - maxPriorityFeePerGas: The maximum priority fee per unit of gas for this transaction.
 */
function normalizeGasFees(_a) {
    return tslib_1.__awaiter(this, arguments, void 0, function* ({ logger, gasPriceMin, gasPriceMax, gasPriceMultiplier, suggestFees, }) {
        try {
            const suggestedFee = yield suggestFees();
            const baseFee = (0, index_1.maxBigNumber)(suggestedFee.baseFee, gasPriceMin || ethers_1.constants.Zero);
            const maxPriorityFeePerGas = (0, index_1.maxBigNumber)(suggestedFee.maxPriorityFee, gasPriceMin || ethers_1.constants.Zero);
            const maxFeePerGasInit = baseFee
                .add(maxPriorityFeePerGas)
                .mul(gasPriceMultiplier || 100)
                .div(100);
            const maxFeePerGas = gasPriceMax
                ? (0, index_1.minBigNumber)(maxFeePerGasInit, gasPriceMax)
                : maxFeePerGasInit;
            if (maxPriorityFeePerGas.eq(0) || maxFeePerGas.eq(0)) {
                logger.warn(`normalizeGasFees: maxPriorityFeePerGas or maxFeePerGas too low (maxPriorityFeePerGas: ${maxPriorityFeePerGas.toString()} / maxFeePerGas: ${maxFeePerGas.toString()})`);
                return {};
            }
            return {
                maxPriorityFeePerGas,
                maxFeePerGas,
            };
        }
        catch (e) {
            logger.error(`normalizeGasFees error: ${e}`);
            return {};
        }
    });
}
//# sourceMappingURL=normalize-gas-fees.js.map